import React, { Component } from "react"
import ButtonBase from "@mui/material/ButtonBase"
import Typography from "@mui/material/Typography"
import Fade from "@mui/material/Fade"
import Done from "@mui/icons-material/Done"
import Clear from "@mui/icons-material/Clear"
import queryStringify from "querystringify"
import { sanitizeYaml, shuffle } from "../../utilities"
import linkifyHtml from "linkify-html"

export default class MultipleChoice extends Component {
  state = {
    randomizedArray: [],
    selectedAnswer: null,
    isCorrect: null,
  }

  answer = async (roomCode, participantId, answer) => {
    this.setState({ isCorrect: null })

    await fetch(
      `${
        process.env.REACT_APP_SERVER_URL
      }/room/answer?roomCode=${roomCode}&participantId=${participantId}&answer=${answer}&password=${localStorage.getItem(
        "password"
      )}`,
      {
        method: "POST",
        headers: {},
      }
    ).then(async (response) => {
      const isCorrect = await response.json()

      this.setState({ isCorrect })

      if (isCorrect) {
        this.props.setNextVisible()
      }
    })
  }

  areArraysEqual = (a, b) => {
    if (a === b) return true
    if (a == null || b == null) return false
    if (a.length !== b.length) return false

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false
    }
    return true
  }

  render() {
    const { text, risposte, participantId, slideState } = this.props
    const { selectedAnswer, isCorrect } = this.state

    const shuffledAnswers = shuffle(risposte, slideState.positions)

    return (
      <div
        style={{
          maxWidth: "min(960px, calc(100% - 64px))",
          maxHeight: "100%",
          overflow: "auto",
          margin: "0 32px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            textAlign: "center",
            textTransform: "none",
            marginTop: "32px",
            padding: "32px 48px",
            borderRadius: "24px",
            background: "rgba(255, 255, 255, .8)",
            backdropFilter: "blur(16px)",
          }}
        >
          <Typography
            variant="h3"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            dangerouslySetInnerHTML={{
              __html: linkifyHtml(sanitizeYaml(text), {
                target: "_blank",
                attributes: {
                  class: "underlineOnHover",
                },
              }),
            }}
          />
        </div>
        {shuffledAnswers.map((nome, index) => (
          <ButtonBase
            style={{
              width: "100%",
              textAlign: "center",
              textTransform: "none",
              margin:
                index + 1 === risposte.length ? "16px 0 32px 0" : "16px 0 0 0",
              padding: "32px 48px",
              borderRadius: "24px",
              background: "rgba(255, 255, 255, .8)",
              backdropFilter: "blur(16px)",
            }}
            disabled={window.location.pathname === "/admin"}
            onClick={() => {
              this.setState({ selectedAnswer: nome })

              this.answer(
                queryStringify.parse(window.location.search).room,
                participantId,
                nome
              )
            }}
          >
            {(window.location.pathname === "/admin"
              ? risposte[0] === nome
              : selectedAnswer === nome && isCorrect !== null) && (
              <Fade in unmountOnExit>
                {isCorrect || window.location.pathname === "/admin" ? (
                  <Done
                    style={{
                      fontSize: "3rem",
                      marginRight: "16px",
                      marginLeft: "-64px",
                    }}
                  />
                ) : (
                  <Clear
                    style={{
                      fontSize: "3rem",
                      marginRight: "16px",
                      marginLeft: "-64px",
                    }}
                  />
                )}
              </Fade>
            )}
            <Typography
              variant="h3"
              style={{
                fontWeight: 300,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {nome}
            </Typography>
          </ButtonBase>
        ))}
      </div>
    )
  }
}
